// 主聊天布局 —— 左侧 RoomList + 右侧 Outlet
// 竖屏单栏: 用 URL 状态切 class, list 态显示 RoomList, room 态显示 main

import { Outlet, useMatch } from "react-router-dom";

import { RoomList } from "./RoomList";

export function ChatLayout() {
  // 进入具体 Room (/rooms/:roomId) 时, 竖屏切到 room 态
  const inRoom = !!useMatch("/rooms/:roomId");
  return (
    <div
      className={`chat-layout ${inRoom ? "chat-layout--on-room" : "chat-layout--on-list"}`}
    >
      <RoomList />
      <section className="chat-layout__main">
        <Outlet />
      </section>
    </div>
  );
}
